import builder from '../builder';
import InformationCircle from '../../streamline-icons/bold/information-circle.svg';

export default builder('IconInformationCircleBold', InformationCircle);
